export const LOAD_USER_PROFILE_GROUPS_STARTED = "LOAD_USER_PROFILE_GROUPS_STARTED";
export const LOAD_USER_PROFILE_GROUPS_SUCCESS = "LOAD_USER_PROFILE_GROUPS_SUCCESS";
